import { PureComponent, PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  className: string;
}
export default class Subsections extends PureComponent<Props> {
  static defaultProps = {
    className: "",
  };

  render() {
    const { className } = this.props;

    return (
      <div className={`ct-subsections ${className}`}>{this.props.children}</div>
    );
  }
}
